import React, { PureComponent } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { change } from 'redux-form';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import FacebookIcon from 'mdi-react/FacebookIcon';
import GooglePlusIcon from 'mdi-react/GooglePlusIcon';
import LogInForm from './components/LogInForm';
import { login, logout } from '../../redux/actions/loginActions';
import { changeUserViewAs } from '../../redux/actions/sidebarActions';
import { createWarningMessage } from '../../helpers/notification';

class LogInContainer extends PureComponent {
  constructor() {
    super();
    this.state = {
      loggingIn: false,
    };
  }

  componentDidMount() {
    // const { logout: logoutAction } = this.props;
    // logoutAction();
  }

  handleSubmit = (values) => {
    this.setState(prevState => ({ loggingIn: !prevState.loggingIn }));

    const { login: loginAction, history, changeFormValue } = this.props;
    changeFormValue('LogInForm', 'password', '***************');
    return loginAction(values, {
      onSuccess: ({ encuestasPendientes = [] }) => {
        if (encuestasPendientes.length) {
          createWarningMessage(`Tienes encuestas pendientes de responder: ${encuestasPendientes.join(',')}`);
        }

        const currentUser = JSON.parse(localStorage.getItem('currentUser')) || {};
        if (currentUser.esAlumno) {
          this.changeUserView(0);
          history.push('/pages/student-dashboard');
          return;
        }

        if (currentUser.esProfesor) {
          this.changeUserView(1);
          history.push('/pages/profesor-dashboard');
          return;
        }

        history.push('/pages/one');
      },
      onFirstLogin: () => {
        history.push('/first_log_in');
      },
      onError: () => {
        createWarningMessage('Usuario y/o contraseña incorrecto');
        this.setState(prevState => ({ loggingIn: !prevState.loggingIn }));
      },
    });
  }

  changeUserView = (userType) => {
    const { dispatch } = this.props;
    dispatch(changeUserViewAs(userType));
  }

  render() {
    const { loggingIn } = this.state;

    return (
      <div className="account">
        <div className="account__wrapper">
          <div className="account__card">
            <div className="account__head">
              <h3 className="account__title">Bienvenido a
                <span className="account__logo"> Integral
                  <span className="account__logo-accent">FIUNI</span>
                </span>
              </h3>
              <h4 className="account__subhead subhead">Facultad de Ingenier&iacute;a</h4>
            </div>
            <LogInForm
              onSubmit={this.handleSubmit}
              loggingIn={loggingIn}
            />
            <div className="account__or d-none">
              <p>Or Easily Using</p>
            </div>
            <div className="account__social d-none">
              <Link
                className="account__social-btn account__social-btn--facebook"
                to="/pages/one"
              ><FacebookIcon />
              </Link>
              <Link
                className="account__social-btn account__social-btn--google"
                to="/pages/one"
              ><GooglePlusIcon />
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

LogInContainer.propTypes = {
  history: PropTypes.shape({}).isRequired,
  login: PropTypes.func.isRequired,
  changeFormValue: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => bindActionCreators({
  login,
  logout,
  changeFormValue: change,
  dispatch,
}, dispatch);

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(LogInContainer));
